/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_TitleInputs */

const tr_landing_cockpit_title = /** @type {(inputs: Landing_Cockpit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bütün pazaryerlerinizi`)
};

const en_landing_cockpit_title = /** @type {(inputs: Landing_Cockpit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring every marketplace`)
};

const de_landing_cockpit_title = /** @type {(inputs: Landing_Cockpit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bringen Sie alle Ihre Marktplätze`)
};

const ru_landing_cockpit_title = /** @type {(inputs: Landing_Cockpit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все ваши маркетплейсы`)
};

/**
* | output |
* | --- |
* | "Bring every marketplace" |
*
* @param {Landing_Cockpit_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_title = /** @type {((inputs?: Landing_Cockpit_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_title(inputs)
	if (locale === "de") return de_landing_cockpit_title(inputs)
	if (locale === "ru") return ru_landing_cockpit_title(inputs)
	return tr_landing_cockpit_title(inputs)
});